module.exports = __webpack_public_path__ + "static/media/survey-of-pakistan-1.7c8c0640.jpg";